import client from '../axios';
import { getErrorMessage } from '../errorBuilder';
import { get, post, setSession } from '../service';

class Session {
  constructor(token, expiresIn) {
    this.token = token;
    this.expiry = new Date().getTime() + expiresIn * 1000;
  }
}

export const login = async (username, password) => {
  const response = await client.post('/auth/login', {
    email: username,
    password,
  });

  if (response.status === 200) {
    const responseData = response.data;

    if (responseData.message === 'User Logged In Successfully!') {
      const authResponse = responseData?.data?.authResponse;
      const userData = responseData?.data?.userData;
      const councilInfo = responseData?.data?.clientData;

      const session = new Session(authResponse?.AccessToken, authResponse?.ExpiresIn);

      setSession(session);

      return {
        session,
        userData,
        councilInfo,
      };
    } else {
      throw new Error('Not Implemented yet');
    }
  }

  throw new Error('Login failed');
};

export const registration = async (payload) => {
  try {
    const response = await client.post('/auth/register', payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Registration failed. Please try again.'));
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await client.post('/auth/forgot-password', {
      email: email,
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to send reset code. Please try again.'));
  }
};

export const resetPassword = async (email, password, code) => {
  try {
    const response = await client.post('/auth/reset-password', {
      email,
      password,
      code,
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to reset password. Please try again.'));
  }
};

export const resendVerificationCode = async (email) => {
  try {
    const response = await client.post('/auth/resend-verification-code', {
      email: email,
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(
      getErrorMessage(error, 'Failed to resend verification code. Please try again.')
    );
  }
};

export const confirmUser = async (email, code) => {
  try {
    const response = await client.post('/auth/confirm-user', {
      email,
      code,
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Verification failed. Please try again.'));
  }
};

export const changePassword = async (payload) => {
  try {
    const response = await post('/auth/change-password', payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to change password. Please try again.'));
  }
};

export const updateEmail = async (payload) => {
  try {
    const response = await post('/auth/update-email', payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to update email. Please try again.'));
  }
};

export const verifyEmail = async (payload) => {
  try {
    const response = await post('/auth/verify-email', payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Email verification failed. Please try again.'));
  }
};

export const resendEmailVerificationCode = async () => {
  try {
    const response = await get('/auth/resend-email-verification-code');

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(
      getErrorMessage(error, 'Failed to resend verification code. Please try again.')
    );
  }
};
